"use strict";
/**
|--------------------------------------------------
| Adds scroll down and scroll up classes to body, adds scroll top class when scroll < header height
|--------------------------------------------------
*/
export const initScrollClasses = (headerSelector) => {
	const header = document.querySelector(headerSelector);
	if(!header) return;

	const headerHeight = header.offsetHeight;
	const body = document.body;

	const scrollTop = 'scroll-top';
	const scrollUp = 'scroll-up';
	// const scrollDown = 'scroll-down';
	const scrollDown = 'scroll-top';

	let lastScroll = 0;

	window.addEventListener('scroll', () => {
		const currentScroll = window.scrollY;
		if (currentScroll <= headerHeight) {
			body.classList.remove(scrollUp, scrollDown);
			body.classList.add(scrollTop);
			return;
		}

		if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
			// down
			body.classList.remove(scrollUp);
			body.classList.remove(scrollTop);
			body.classList.add(scrollDown);
		} else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
			// up
			body.classList.remove(scrollDown);
			body.classList.remove(scrollTop);
			body.classList.add(scrollUp);
		}
		lastScroll = currentScroll;
	})
}

/**
|--------------------------------------------------
| Window Accessible Modal Function
|--------------------------------------------------
*/
import Modal from "bootstrap/js/dist/modal";
export const initModal = function(modalSelector, forceOpen = false) {
	const modalElement = document.querySelector(modalSelector);
	
	if (!modalElement) {
		console.log(`Modal with selector ${modalSelector} is missing!`)
		return;
	};
	
	let bsModal = Modal.getOrCreateInstance(modalSelector);

	if(forceOpen){
		bsModal.show();
	}

};

/**
|--------------------------------------------------
| Non-breaking JSON parse that allows a default value
|--------------------------------------------------
*/

export const safelyParseJSON = function(json, defaultValue = {}) {
	let parsed
	try {
	  parsed = JSON.parse(json)
	} catch (e) {
		console.error('Error parsing JSON:', e)
		console.log('Using default value as JSON parse failed.')
	  	parsed = defaultValue
	}
	return parsed
}


$('#select-categoria').on( "change", function() {
	$( ".select2-selection__rendered" ).prepend( "<span>Categoria: </span>" );
});
$( ".select2-selection__rendered" ).prepend( "<span>Categoria: </span>" );

